import { typography, screenSizeBreakpoints, contentMaxWidth, headerBarHeight } from './common.theme';

const colors = {
  primary: '#FFFFFF',
  secondary: '#d5d5d8',
  tertiary: '#ecf1f7',
  emphasized: '#5C73E7',
  detail: '#A8B1FF',
  text: {
    primary: '#061328',
    secondary: '#3A5CCC',
    tertiary: '#182d4c',
    emphasized: '#5C73E7',
    detail: '#A8B1FF'
  },
  heading: {
    primary: '#061328',
    secondary: '#626d8e',
    tertiary: '#182d4c',
    emphasized: '#5C73E7',
    detail: '#A8B1FF'
  }
};

const theme = {
  colors: colors,
  typography: typography,
  screenSizeBreakpoints: screenSizeBreakpoints,
  contentMaxWidth: contentMaxWidth,
  headerBarHeight: headerBarHeight,
};

export default theme;
